import React from "react";
import PropTypes from "prop-types";

import FormSelect from "../FormUi/FormSelect";
import FormField from "../FormUi/FormField";
import AddForm from "./AddForm";
import ExportButton from "../ExportButton";
import classNames from "classnames";


const Filtering = ({
  locations,
  accessLevels,
  dataForms,
  name,
  startDate,
  endDate,
  location,
  accessLevel,
  formId,
  onChange,
  addFormOpen
}) => (
  <span>
    <div className="row">
      <div className="col-sm-12 col-md-8">
        <div className="row">
          <div className="col-sm-12 col-md-4">
            <FormField name="name"
              placeholder="Search"
              value={name}
              onChange={onChange}
            />
          </div>
          <div className="col-sm-12 col-md-4">
            <FormSelect _key="id"
              _val="name"
              name="location"
              value={location}
              options={locations}
              onChange={onChange}
            />
          </div>
          <div className="col-sm-12 col-md-4">
            <FormSelect _key="id"
              _val="title"
              name="formId"
              value={formId}
              options={dataForms}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-4">
            <FormSelect _key="key"
              _val="value"
              name="accessLevel"
              value={accessLevel}
              options={accessLevels}
              onChange={onChange}
            />
          </div>
          <div className="col-sm-12 col-md-4">
            <FormField name="startDate"
              placeholder="Start Date"
              value={startDate}
              onChange={onChange}
              type="date"
            />
          </div>
          <div className="col-sm-12 col-md-4">
            <FormField name="endDate"
              placeholder="End Date"
              value={endDate}
              onChange={onChange}
              type="date"
            />
          </div>
        </div>
      </div>
      <div className="col-ms-12 col-md-4">
        <div className="pull-right">
          <AddForm visible={addFormOpen} location={location} />
          <ExportButton url="/export/completed_forms"
            className={classNames(
              "btn btn-indigo btn-raised btn-long margin-left-five",
              { disabled: false }
            )}
            search={name}
            location={location}
            accessLevel={accessLevel}
            formId={formId}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
        <div className="clearfix"></div>
      </div>
    </div>
  </span>
);

Filtering.propTypes = {
  locations: PropTypes.array,
  dataFields: PropTypes.array,
  accessLevels: PropTypes.array,
  dataForms: PropTypes.array,
  name: PropTypes.string,
  location: PropTypes.string,
  accessLevel: PropTypes.string,
  formId: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onChange: PropTypes.func,
  addFormOpen: PropTypes.bool
};

export default Filtering;
